import React from "react";
import styled from "styled-components";

const Invalid = styled.span`
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  font-weight: 400;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  line-height: 18px;
  color: #e74c3c;
  @media(max-width: 959px) {
    font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  }
  @media(max-width: 480px) {
    font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "12px"};
  }
`;

export default props =>
  <Invalid>
    {props.children}
  </Invalid>;



// WEBPACK FOOTER //
// ./src/components/ErrorText.js